export function $timeout(callback, timeout, cancelSignal) {
    const stopAbortListener = (cancelSignal === void 0)
        ? () => {
        }
        : cancelSignal.whenAborted(() => {
            clearTimeout(timer);
        });
    const timer = setTimeout(() => {
        stopAbortListener();
        callback();
    }, timeout);
}
export function $interval(callback, timeout, cancelSignal) {
    const timer = setInterval(callback, timeout);
    cancelSignal.whenAborted(() => {
        clearTimeout(timer);
    });
}
//# sourceMappingURL=snipets.js.map